<template>
  <div>
    <div id="map" class="map-container" :style="{ height: height }"></div>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import store from "@/store"

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  name: "LeafletMap",
  props: {
    modelValue: { 
      type: Array,
      default: () => null,
    },
    center: {
      type: Array,
      default: () => [35.86902, 128.59909],
    },
    zoom: {
      type: Number,
      default: 10,
    },
    height: {
      type: String,
      default: "50vh",
    },
    clickable: { 
      type: Boolean,
      default: true,
    },
    imageUrl: { type: String, default: "" },
  },
  data() {
    return {
      map: null,
      marker: null,
    };
  },
  watch: {
    modelValue(val) {
      if (!this.map || !Array.isArray(val) || val.length !== 2) return;
      this.updateMarker(val);
      this.map.setView(val, this.map.getZoom());
    },
    center(val) {
      if (!this.map || !Array.isArray(val) || val.length !== 2) return;
      this.map.setView(val, this.map.getZoom());
    },
  },
  mounted() {
    this.map = L.map('map', {
      attributionControl: false
    }).setView(this.center, this.zoom);

    // 2) prefix 없이 Attribution 컨트롤을 다시 추가
    L.control.attribution({ prefix: false }).addTo(this.map);

    // 3) 타일 레이어 추가 (OSM 출처만 표시)
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(this.map);

    // ✅ 클릭 이벤트 (props로 제어)
    if (this.clickable) {
      this.map.on("click", (e) => {
        const { lat, lng } = e.latlng;

        this.$emit("update:modelValue", [lat, lng]);

        const html = this.makePopupHtml(lat, lng);
        if (this.marker) {
          this.marker.setLatLng([lat, lng]).bindPopup(html).openPopup();
        } else {
          this.marker = L.marker([lat, lng]).addTo(this.map).bindPopup(html).openPopup();
        }
      });
    }

    // ✅ 초기 마커 표시
    if (this.modelValue) {
      const [lat, lng] = this.modelValue;
      const html = this.makePopupHtml(lat, lng);
      this.marker = L.marker(this.modelValue).addTo(this.map).bindPopup(html).openPopup();
      this.map.setView(this.modelValue, this.zoom);
    }
  },
  beforeDestroy() {
    if (this.map) this.map.remove();
  },
  methods: {
    makePopupHtml(lat, lng) {
      const latTxt = `위도: ${Number(lat).toFixed(5)}`;
      const lngTxt = `경도: ${Number(lng).toFixed(5)}`;
      const hasImg = !!this.imageUrl;

      return `
        <div class="popup-card">
          ${hasImg ? `
            <div class="popup-img">
              <img src="${this.imageUrl}" alt="thumbnail" />
            </div>
          ` : ""}
          <div class="popup-body p-1">
            <div class="line">${latTxt}</div>
            <div class="line">${lngTxt}</div>
          </div>
        </div>
      `;
    },
    updateMarker([lat, lng]) {
      const html = this.makePopupHtml(lat, lng);
      if (!this.marker) {
        this.marker = L.marker([lat, lng]).addTo(this.map);
      } else {
        this.marker.setLatLng([lat, lng]);
      }
      this.marker.bindPopup(html).openPopup();
    },
  },
};
</script>

<style>
.map-container {
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

/* ✅ 팝업 레이아웃 */
.leaflet-popup-content {
  margin: 10px 12px;
}

.popup-card {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 260px;
}

.popup-img {
  flex: 0 0 auto;
  width: 56px;         /* 필요 시 조절 */
  height: 56px;
  border-radius: 8px;
  overflow: hidden;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
}
.popup-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.popup-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  line-height: 1.3;
  font-size: 13px;
}
.popup-body .line {
  white-space: nowrap;
}
</style>
